import { parrotApi } from '@libs/openapi';
import parrotSdk from '@libs/parrot-sdk';
import { defineModel } from 'foca';
import { PoolStruct } from 'parrot-sui-sdk';
import { OpenapiClientParrot } from 'src/openapi/parrot';
import type { ParrotPoolStruct } from 'src/types';

const duration = 60 * 1000; // 1 minutes

interface coinStateStruct {
  loading: Record<string, boolean>;
  pools: Record<
    string,
    ParrotPoolStruct & {
      timestamp: number;
    }
  >;
}

const initialState: coinStateStruct = {
  loading: {},
  pools: {},
};

export const poolParrotModel = defineModel('pool-parrot', {
  initialState,
  methods: {
    buildPool(pools: (PoolStruct | OpenapiClientParrot.GetClmmPoolsByPoolIdResponse)[]) {
      let _pools: Record<
        string,
        ParrotPoolStruct & {
          timestamp: number;
        }
      > = {};

      pools.forEach((pool) => {
        _pools[pool.pool_id] = {
          ...pool,
          timestamp: Date.now(),
        };
      });

      this.setState((state) => {
        state.pools = {
          ...state.pools,
          ..._pools,
        };
      });
    },
    // http get
    async getHttpPools(query: OpenapiClientParrot.GetClmmPoolsQuery) {
      const result = await parrotApi.get('/clmm/pools', {
        query,
      });

      this.buildPool(result.result);
      return result;
    },
    async getHttpPoolsByPoolIds(query: OpenapiClientParrot.GetClmmPoolsIdsQuery) {
      const result = await parrotApi.get('/clmm/pools/ids', {
        query: query,
      });
      this.buildPool(result);
      return result;
    },
    async getHttpPoolsByPoolId(params: OpenapiClientParrot.GetClmmPoolsByPoolIdOhlcParams) {
      if (this.state.pools[params.pool_id]) return this.state.pools[params.pool_id];

      this.setState((state) => {
        state.loading[params.pool_id] = true;
      });

      const result = await parrotApi.get('/clmm/pools/{pool_id}', {
        params,
      });
      this.buildPool([result]);

      this.setState((state) => {
        state.loading[params.pool_id] = false;
      });

      return result;
    },

    // rpc get
    async getPools(page: number = 1, limit: number = 100) {
      const pools = await parrotSdk.Pool.getPools(page, limit);

      this.buildPool(pools.result);

      return pools;
    },

    async getPool(poolId: string) {
      if (this.state.loading[poolId]) return;
      if (this.state.pools[poolId]) return this.state.pools[poolId];

      this.setState((state) => {
        state.loading[poolId] = true;
      });
      const pool = await parrotSdk.Pool.getPool(poolId);

      this.buildPool([pool]);

      this.setState((state) => {
        state.loading[poolId] = false;
      });

      return pool;
    },

    async getPoolsByPoolIds(poolIds: string[]) {
      const pools = await parrotSdk.Pool.getPoolsByIds(poolIds);
      this.buildPool(pools);
      return pools;
    },
  },
});
